<input #searchBox
    type="search"
    aria-label="search"
    placeholder="搜索"
    (input)="doSearch()"
    (keyup)="doSearch()"
    (focus)="doFocus()"
    (click)="doSearch()">